<template>
    <Loading v-if="serviceLoading" />
    <div v-else>
        <div v-if="isMobileView">
            <div v-if="visibleRows.length" class="mobile-pendency-thread">
                <article v-for="row in visibleRows" :key="row.key" class="mobile-thread-card" :class="[
                    !serviceLoading ? (row.status?.id ? `pendency--status--${row.status.id}` : `pendency--status--${row.statusId}`) : null,
                    { 'policy--expanded': showReplies },
                    { 'mobile-thread-card--toggleable': row.canToggle },
                ]">
                    <header class="data-card__header">
                        <div class="data-card__identity">
                            <span class="data-card__name">{{ displayUserName(row.user) }}</span>
                            <small>{{ formatDate(row.createdAt) }}</small>
                        </div>

                        <div class="actions-wrapper" style="margin: 0 !important;">
                            <div v-if="row.canToggle" class="row__data row__data--small row__data--more"
                                :class="{ 'row__data--rotate': showReplies }"
                                @click="row.canToggle ? toggleReplies() : null" style="width: 22px; height: 22px;">
                            </div>
                        </div>
                    </header>

                    <dl class="data-card__details">
                        <div class="data-card__detail data-card__detail-full">
                            <dt>{{ $t('pendenciesTable.status') }}</dt>
                            <dd>{{ row.status?.name ?? row.statusName }}</dd>
                        </div>
                        <div class="data-card__detail data-card__detail-full">
                            <dt>{{ $t('pendenciesTable.description') }}</dt>
                            <dd>{{ row.description || '-----' }}</dd>
                        </div>
                        <div class="data-card__detail data-card__detail-full">
                            <dt>{{ $t('pendenciesTable.deadline') }}</dt>
                            <dd>{{ row.deadline ? formatDate(row.deadline) : $t(`dashboard.statistics.${"noDeadline"}`)
                            }}</dd>
                        </div>
                        <div class="data-card__detail data-card__detail-full">
                            <dt>{{ $t('pendenciesTable.responsible') }}</dt>
                            <dd>{{ displayUserName(row.agent) }}</dd>
                        </div>
                    </dl>

                    <div class="actions-wrapper">
                        <template v-if="row.kind === 'latest-reply'">
                            <div v-if="hasAnyFiles" class="row__data row__data--small row__data--pdf icon"
                                :class="'icon__pdf--active'" @click.stop="openPendencyFilesModal()"></div>
                            <div v-else class="row__data row__data--small row__data--pdf icon icon__pdf"
                                @click.stop="openPendencyFilesModal()"></div>

                            <div class="icon icon__add tool-icon"
                                @click.stop="showAddReplyPendencyModal(policy ? policy.id : null, service.id, agent, service.user);">
                            </div>

                            <div v-if="canEditPendency" class="icon icon__edit tool-icon"
                                @click.stop="showEditReplyModal(row.item, service.policy ? service.policy.id : null, service.agent, service.user)">
                            </div>
                            <div v-else class="icon icon__edit tool-icon" style="cursor:no-drop;"></div>

                            <div v-if="canDeletePendency" class="icon icon__delete tool-icon"
                                :class="{ 'icon__delete--active': activeReplyId === row.item.id }" tabindex="-1"
                                @focus="activeReplyId = row.item.id" @focusout="activeReplyId = null">
                                <transition name="fade">
                                    <div class="delete" v-if="activeReplyId === row.item.id">
                                        <div class="delete__text">{{ $t('pendenciesTable.replyDeleteConfirm') }}</div>
                                        <div class="delete__buttons">
                                            <div class="button button--confirm"
                                                @click.stop="deletePendencyReply(row.item.id)"></div>
                                            <div class="button button--cancel" @click.stop="closeReplyDeletePopup">
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <div v-else class="icon icon__delete tool-icon" style="cursor:no-drop;"></div>
                        </template>

                        <template v-else-if="row.kind === 'reply'">
                            <div class="row__data row__data--small row__data--more"
                                :class="{ 'row__data--rotate': showReplies }" @click.stop="toggleReplies"
                                v-if="row.canToggle"></div>

                            <div class="icon icon__edit tool-icon"
                                @click.stop="showEditReplyModal(row.item, service.policy ? service.policy.id : null, service.agent, service.user)">
                            </div>
                            <div class="icon icon__delete tool-icon"
                                :class="{ 'icon__delete--active': activeReplyId === row.item.id }" tabindex="-1"
                                @focus="activeReplyId = row.item.id" @focusout="activeReplyId = null">
                                <transition name="fade">
                                    <div class="delete" v-if="activeReplyId === row.item.id">
                                        <div class="delete__text">{{ $t('pendenciesTable.replyDeleteConfirm') }}</div>
                                        <div class="delete__buttons">
                                            <div class="button button--confirm"
                                                @click.stop="deletePendencyReply(row.item.id)"></div>
                                            <div class="button button--cancel" @click.stop="closeReplyDeletePopup">
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </template>

                        <template v-else>
                            <div class="row__data row__data--small row__data--more"
                                :class="{ 'row__data--rotate': showReplies }" @click.stop="toggleReplies"
                                v-if="row.canToggle"></div>

                            <div class="icon icon__edit tool-icon" @click.stop="showEditPendencyModal(service)"></div>
                            <div class="icon icon__delete tool-icon"
                                :class="{ 'icon__delete--active': showDeletePendency }" tabindex="-1"
                                @focus="showDeletePendency = true" @focusout="showDeletePendency = false">
                                <transition name="fade">
                                    <div class="delete" v-if="showDeletePendency">
                                        <div class="delete__text">{{ $t('pendenciesTable.pendencyDeleteConfirm') }}
                                        </div>
                                        <div class="delete__buttons">
                                            <div class="button button--confirm" @click.stop="deletePendency()"></div>
                                            <div class="button button--cancel" @click.stop="closeDeletePopup()"></div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </template>
                    </div>
                </article>
            </div>

            <article v-else class="mobile-thread-card" :class="[`pendency--status--${status.id}`]">
                <header class="data-card__header">
                    <div class="data-card__identity">
                        <span class="data-card__name">{{ displayUserName(service.user) }}</span>
                        <small>{{ formatDate(created) }}</small>
                    </div>
                </header>

                <dl class="data-card__details">
                    <div class="data-card__detail data-card__detail-full">
                        <dt>{{ $t('pendenciesTable.status') }}</dt>
                        <dd>{{ status.name }}</dd>
                    </div>
                    <div class="data-card__detail data-card__detail-full">
                        <dt>{{ $t('pendenciesTable.description') }}</dt>
                        <dd>{{ description || '-----' }}</dd>
                    </div>
                    <div class="data-card__detail data-card__detail-full">
                        <dt>{{ $t('pendenciesTable.deadline') }}</dt>
                        <dd>{{ deadline ? formatDate(deadline) : $t(`dashboard.statistics.${"noDeadline"}`) }}</dd>
                    </div>
                    <div class="data-card__detail data-card__detail-full">
                        <dt>{{ $t('pendenciesTable.responsible') }}</dt>
                        <dd>{{ agent.first_name }} {{ agent.last_name }}</dd>
                    </div>
                </dl>
            </article>
        </div>

        <div v-else>
            <div v-if="visibleRows.length" class="policy-service-list">
                <div v-for="row in visibleRows" :key="row.key" class="policy-service" :class="row.wrapperClass">
                    <div class="policy-service__row">
                        <div class="policy-service__data sender-data">
                            <div class="sender">
                                <p class="sender-name">{{ displayUserName(row.user) }}</p>
                                <p>{{ formatDate(row.createdAt) }}</p>
                            </div>

                            <div class="contact">
                                <a v-if="row.user?.phone" :href="'tel:' + row.user.phone">
                                    <div class="icon icon__phone--active"></div>
                                </a>
                                <div v-else class="icon icon__phone"></div>

                                <a v-if="row.user?.email" :href="'mailto:' + row.user.email">
                                    <div class="icon icon__mail--active"></div>
                                </a>
                                <div v-else class="icon icon__mail"></div>
                            </div>
                        </div>

                        <div class="policy-service__data message-data">
                            <p v-if="row.description">{{ row.description }}</p>
                            <p v-else>-----</p>
                        </div>

                        <div class="policy-service__data deadline-data medium-data">
                            <p class="deadline">
                                <span v-if="row.deadline">{{ formatDate(row.deadline) }}</span>
                                <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                            </p>
                            <p>{{ displayUserName(row.agent) }}</p>
                        </div>

                        <div class="policy-service__data status-data medium-data">
                            <div class="status-indicator"
                                :class="`status-indicator--${row.status?.id ?? row.statusId}`"></div>
                            <p>{{ row.status?.name ?? row.statusName }}</p>
                        </div>

                        <div class="policy-service__data tools-data">
                            <template v-if="row.kind === 'latest-reply'">
                                <div class="icon icon__add tool-icon"
                                    @click="showAddReplyPendencyModal(policy ? policy.id : null, service.id, agent, service.user);">
                                </div>

                                <div v-if="hasAnyFiles" class="icon icon__pdf--active tool-icon"
                                    @click="openPendencyFilesModal()"></div>
                                <div v-else class="icon icon__pdf tool-icon"></div>

                                <div v-if="canEditPendency" class="icon icon__edit tool-icon"
                                    @click="showEditReplyModal(row.item, service.policy ? service.policy.id : null, service.agent, service.user)">
                                </div>
                                <div v-else class="icon icon__edit tool-icon" style="cursor:no-drop;"></div>

                                <div v-if="canDeletePendency" class="icon icon__delete tool-icon"
                                    :class="{ 'icon__delete--active': activeReplyId === row.item.id }" tabindex="-1"
                                    @focus="activeReplyId = row.item.id" @focusout="activeReplyId = null">
                                    <transition name="fade">
                                        <div class="delete" v-if="activeReplyId === row.item.id">
                                            <div class="delete__text">
                                                {{ $t('pendenciesTable.replyDeleteConfirm') }}
                                            </div>
                                            <div class="delete__buttons">
                                                <div class="button button--confirm"
                                                    @click="deletePendencyReply(row.item.id)"></div>
                                                <div class="button button--cancel" @click="closeReplyDeletePopup"></div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                                <div v-else class="icon icon__delete tool-icon" style="cursor:no-drop;"></div>
                            </template>

                            <template v-else-if="row.kind === 'reply'">
                                <div class="icon tool-icon"></div>
                                <div class="icon tool-icon"></div>
                                <div class="icon icon__edit tool-icon"
                                    @click="showEditReplyModal(row.item, service.policy ? service.policy.id : null, service.agent, service.user)">
                                </div>
                                <div class="icon icon__delete tool-icon"
                                    :class="{ 'icon__delete--active': activeReplyId === row.item.id }" tabindex="-1"
                                    @focus="activeReplyId = row.item.id" @focusout="activeReplyId = null">
                                    <transition name="fade">
                                        <div class="delete" v-if="activeReplyId === row.item.id">
                                            <div class="delete__text">
                                                {{ $t('pendenciesTable.replyDeleteConfirm') }}
                                            </div>
                                            <div class="delete__buttons">
                                                <div class="button button--confirm"
                                                    @click="deletePendencyReply(row.item.id)"></div>
                                                <div class="button button--cancel" @click="closeReplyDeletePopup"></div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </template>

                            <template v-else>
                                <div class="icon tool-icon"></div>
                                <div class="icon tool-icon"></div>
                                <div class="icon icon__edit tool-icon" @click="showEditPendencyModal(service)"></div>
                                <div class="icon icon__delete tool-icon"
                                    :class="{ 'icon__delete--active': showDeletePendency }" tabindex="-1"
                                    @focus="showDeletePendency = true" @focusout="showDeletePendency = false"
                                    ref="delete">
                                    <transition name="fade">
                                        <div class="delete" v-if="showDeletePendency">
                                            <div class="delete__text">
                                                {{ $t('pendenciesTable.pendencyDeleteConfirm') }}
                                            </div>
                                            <div class="delete__buttons">
                                                <div class="button button--confirm" @click="deletePendency()"></div>
                                                <div class="button button--cancel" @click="closeDeletePopup()"></div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </template>
                        </div>

                        <div class="policy-service__data arrow-data">
                            <div v-if="row.canToggle" class="icon icon__chevron-down-green" @click="toggleReplies"
                                :class="showReplies ? 'rotate-chevron' : ''">
                            </div>
                            <div v-else-if="row.kind === 'latest-reply'" class="icon icon__chevron-down-gray"
                                style="cursor: initial;"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="policy-service" :class="[
                { 'animate__animated animate__zoomOutLeft': serviceIsDeleting === service.id },
                { deleting: isServiceDeleted },
            ]">
                <div class="policy-service__row">
                    <div class="policy-service__data sender-data">
                        <div class="sender">
                            <p class="sender-name">{{ displayUserName(service.user) }}</p>
                            <p>{{ formatDate(created) }}</p>
                        </div>

                        <div class="contact">
                            <a v-if="service.user?.phone" :href="'tel:' + service.user.phone">
                                <div class="icon icon__phone--active"></div>
                            </a>
                            <div v-else class="icon icon__phone"></div>

                            <a v-if="service.user?.email" :href="'mailto:' + service.user.email">
                                <div class="icon icon__mail--active"></div>
                            </a>
                            <div v-else class="icon icon__mail"></div>
                        </div>
                    </div>

                    <div class="policy-service__data message-data">
                        <p v-if="description">{{ description }}</p>
                        <p v-else>-----</p>
                    </div>

                    <div class="policy-service__data deadline-data medium-data">
                        <p class="deadline">
                            <span v-if="deadline">{{ formatDate(deadline) }}</span>
                            <span v-else>{{ $t(`dashboard.statistics.${"noDeadline"}`) }}</span>
                        </p>
                        <p>{{ agent.first_name }} {{ agent.last_name }}</p>
                    </div>

                    <div class="policy-service__data status-data medium-data">
                        <div class="status-indicator" :class="`status-indicator--${status.id}`"></div>
                        <p>{{ status.name }}</p>
                    </div>

                    <div class="policy-service__data tools-data  ">
                        <div class="icon icon__add tool-icon"
                            @click="showAddReplyPendencyModal(policy ? policy.id : null, service.id, agent, service.user);">
                        </div>

                        <div v-if="hasAnyFiles" class="icon icon__pdf--active tool-icon"
                            @click="openPendencyFilesModal()">
                        </div>
                        <div v-else class="icon icon__pdf tool-icon"></div>

                        <div class="icon icon__edit tool-icon" @click="showEditPendencyModal(service)"></div>

                        <div class="icon icon__delete tool-icon" :class="{ 'icon__delete--active': showDeletePendency }"
                            tabindex="-1" @focus="showDeletePendency = true" @focusout="showDeletePendency = false"
                            ref="delete">
                            <transition name="fade">
                                <div class="delete" v-if="showDeletePendency">
                                    <div class="delete__text">
                                        {{ $t('pendenciesTable.pendencyDeleteConfirm') }}
                                    </div>
                                    <div class="delete__buttons">
                                        <div class="button button--confirm" @click="deletePendency()"></div>
                                        <div class="button button--cancel" @click="closeDeletePopup()"></div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <div class="policy-service__data arrow-data">
                        <div v-if="reversedReplies.length > 0" class="icon icon__chevron-down-green"
                            @click="toggleReplies" :class="showReplies ? 'rotate-chevron' : ''">
                        </div>
                        <div v-else class="icon icon__chevron-down-gray" style="cursor: initial;"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import { extractEntityTeamIds } from "@/helpers/teamAuthorization";

defineOptions({
    name: "PendencyService"
});

const props = defineProps({
    service: { required: true, type: Object },
    replies: { required: true, type: Array },
    policy: { type: Object },
    agent: { required: true, type: Object },
    created: { required: true, type: String },
    description: { type: String },
    deadline: { type: String },
    receiver: { required: true, type: Object },
    status: { required: true, type: Object },
    offer: { type: [Array, Object], required: false },
});

const emit = defineEmits(['toggle-replies']);
const store = useStore();

// State
const showDeletePendency = ref(false);
// const showDeleteReply = ref(false);
const activeReplyId = ref(null);
const showReplies = ref(false);
const serviceLoading = ref(false);
const serviceIsDeleting = ref("");
const replyIsDeleting = ref("");
const isServiceDeleted = ref(false);
const isReplyDeleted = ref(false);

const isMobileView = ref(false);

const updateMobileView = () => {
    isMobileView.value = window.innerWidth <= 900;
};

onMounted(() => {
    updateMobileView();
    window.addEventListener("resize", updateMobileView);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", updateMobileView);
});

// Template Refs
// Note: Multiple delete elements exist in template, handled via focus/focusout bindings

// Computed
// const policyForms = computed(() => store.getters.policyForms);
// const language = computed(() => store.getters.language);
const loggedUser = computed(() => store.getters.loggedUser);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const costumerId = computed(() => store.getters.customerDetailsId);
const pendencyTargetTeams = computed(() => extractEntityTeamIds(
    props.receiver
    ?? props.policy?.customer
    ?? store.getters.customer
    ?? props.service?.customer
    ?? {}
));
const canEditPendency = computed(() => {
    if (isSuperAdmin.value) return true;
    return pendencyTargetTeams.value.length > 0
        ? store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)
        : false;
});
const canDeletePendency = computed(() => {
    if (isSuperAdmin.value) return true;
    return pendencyTargetTeams.value.length > 0
        ? store.getters.canPerformActionOnEntity("pendency_delete", pendencyTargetTeams.value)
        : false;
});
const displayUserName = (user) => [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "-";

const reversedReplies = computed(() => [...(props.replies || [])].reverse());
const latestReply = computed(() => (props.replies && props.replies.length > 0 ? reversedReplies.value[0] : null));
const filteredReversedReplies = computed(() => reversedReplies.value.slice(1));
const visibleRows = computed(() => {
    const rows = [];

    if (latestReply.value) {
        rows.push({
            key: `reply-${latestReply.value.id}`,
            kind: 'latest-reply',
            item: latestReply.value,
            user: latestReply.value.user,
            createdAt: latestReply.value.created_at,
            description: latestReply.value.description,
            deadline: latestReply.value.deadline,
            agent: latestReply.value.agent,
            status: latestReply.value.status,
            statusId: latestReply.value.status?.id,
            statusName: latestReply.value.status?.name,
            wrapperClass: [
                { 'animate__animated animate__zoomOutLeft': replyIsDeleting.value === latestReply.value.id },
                { deleting: isReplyDeleted.value },
            ],
            canToggle: true,
        });
    }

    if (showReplies.value) {
        filteredReversedReplies.value.forEach((reply) => {
            rows.push({
                key: `reply-${reply.id}`,
                kind: 'reply',
                item: reply,
                user: reply.user,
                createdAt: reply.created_at,
                description: reply.description,
                deadline: reply.deadline,
                agent: reply.agent,
                status: reply.status,
                statusId: reply.status?.id,
                statusName: reply.status?.name,
                wrapperClass: [
                    { 'animate__animated animate__zoomOutLeft': replyIsDeleting.value === reply.id },
                    { deleting: isReplyDeleted.value },
                ],
                canToggle: true,
            });
        });

        if (props.replies && props.replies.length > 0) {
            rows.push({
                key: `service-${props.service.id}`,
                kind: 'service',
                item: props.service,
                user: props.service.user,
                createdAt: props.created,
                description: props.description,
                deadline: props.deadline,
                agent: props.agent,
                status: props.status,
                statusId: props.status?.id,
                statusName: props.status?.name,
                wrapperClass: [
                    { 'animate__animated animate__zoomOutLeft': serviceIsDeleting.value === props.service.id },
                    { deleting: isServiceDeleted.value },
                ],
                canToggle: false,
            });
        }
    }

    return rows;
});

const hasAnyFiles = computed(() => {
    const serviceHasFiles = props.service.files?.length;
    let offerHasFiles = false;
    if (props.offer) {
        offerHasFiles = Array.isArray(props.offer)
            ? props.offer.some((o) => o?.files?.length)
            : props.offer.files?.length;
    }
    return !!(serviceHasFiles || offerHasFiles);
});

// Methods
const showEditPendencyModal = (service) => {
    store.commit("setShowAddPendencyModal", true);
    store.commit("setIsPendecyEditing", true);
    store.commit("setPendencyEditData", service);
};

const showEditReplyModal = (reply, policyId, agent) => {
    store.commit("setShowAddPendencyModal", true);
    store.commit("setIsReplyEditing", true);
    store.commit("setPendencyForReply", true);
    store.commit("setReplyEditData", { reply, policyId });
    store.commit("setPendencyReplyAgentData", agent);
};

const toggleReplies = () => {
    showReplies.value = !showReplies.value;
    emit('toggle-replies');
};

const showAddReplyPendencyModal = (policyId, serviceId, agent, user) => {
    const isReplying = (loggedUser.value && user && loggedUser.value.id === user.id);
    store.commit("setIsUserReplyingToPendency", isReplying);
    store.commit("setPendencyForReply", true);
    store.commit("setShowAddPendencyModal", true);
    store.commit("setPendencyReplyData", { policyId, serviceId, agent });
};

const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

const closeDeletePopup = () => {
    showDeletePendency.value = false;
};

const deletePendency = async () => {
    if (!canDeletePendency.value) return;

    closeDeletePopup();
    await store.dispatch("deletePendencies", {
        pendencyId: props.service.id,
        customerId: costumerId.value
    });
    isServiceDeleted.value = true;
};

const closeReplyDeletePopup = () => {
    activeReplyId.value = null;
};

const deletePendencyReply = async (id) => {
    if (!canDeletePendency.value) return;

    replyIsDeleting.value = id;
    closeReplyDeletePopup();
    await store.dispatch("deleteReplyPendencies", {
        replyId: id,
        customerId: costumerId.value
    });
    isReplyDeleted.value = true;
    showReplies.value = false;
};

const openPendencyFilesModal = () => {
    if (!isSuperAdmin.value && pendencyTargetTeams.value.length === 0) return;
    if (!isSuperAdmin.value && !store.getters.canPerformActionOnEntity("pendency_edit", pendencyTargetTeams.value)) return;

    const files = props.service.files ? [...props.service.files] : [];

    const addOfferFiles = (offer) => {
        if (!offer?.id) return;

        files.push({
            id: `${offer.policy_offer_code}-Offerte_${offer.id}`,
            name: `${offer.policy_offer_code}-Offerte.pdf`,
            file_name: `${offer.policy_offer_code}-Offerte.pdf`,
            created_at: offer.created_at,
            isDownloadable: true,
            offerId: offer.id,
        });

        if (Array.isArray(offer.files)) {
            files.push(...offer.files);
        }
    };

    const offerItems = Array.isArray(props.offer) ? props.offer : (props.offer ? [props.offer] : []);
    offerItems.forEach(addOfferFiles);

    store.commit("setShowFilesEditModal", true);
    store.commit("setFilesToEditId", props.service.id);
    store.commit("setFilesToEdit", files);
    store.commit("setFilesToEditOffers", offerItems);
    store.commit("setFilesEditMode", 'Pendencies');
};
</script>

<style lang="scss" scoped>
.policy-service {
    max-height: initial !important;
    min-height: 80px !important;
    height: auto !important;
}

.mobile-pendency-thread {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 20px;
    padding-top: 5px;
    border-top: 1px solid var(--text-5);
}

.mobile-thread-card {
    display: flex;
    flex-direction: column;
    gap: 12px; 
    border-radius: 12px;  
        padding: 10px; 
    margin: 10px 0;
    &:last-child {
        margin-bottom: 0;
    }

    border: 1px solid var(--text-5);
}
 
.data-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.data-card__identity {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.data-card__name {
    font-weight: 600;
    color: var(--text-9);
}

.data-card__details {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
}

.data-card__detail {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    font-size: 13px;
    color: var(--text-9);
}

.data-card__detail dt {
    color: var(--text-5);
    font-weight: 500;
}

.data-card__detail dd {
    margin: 0;
    text-align: right;
    word-break: break-word;
}

.actions-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 4px;
}

.delete {
    width: 350px !important;
}

.policy-service__data {
    flex: initial !important;
}

.replies-row {
    margin-top: 14px;
}

.sender-data {
    justify-content: space-between;
}

.sender-data,
.sender,
.contact {

    display: flex;

}

.sender {
    flex-direction: column;
    justify-content: center;
    color: var(--text-9);
}

.sender-name,
.deadline {
    margin-bottom: 5px;
}

.contact {
    margin-right: 20px;
    gap: 15px;
}

.message-data {
    p {
        padding: 10px;
        background-color: white;
        border-radius: 10px;
        margin: 10px 0;
        margin-left: 0;
        width: 100%;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
}

.deadline-data {
    flex-direction: column;
    color: var(--text-9);
}

.status-indicator {
    width: 16px;
    height: 16px;

    border-radius: 10px;
}

.status-indicator--1 {
    background-color: #ff3333;
}

.status-indicator--2 {
    background-color: #FF9E0F;
}

.status-indicator--3 {
    background-color: #22db8e;
}

.status-data {
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
}

.tools-data {
    justify-content: space-around;
}

.tool-icon {
    border: 1px solid transparent;
    height: 100%;
    width: 25%;
    border-left-color: #7F8FA426;
}

.icon__delete {
    border-right-color: #7F8FA426;
}

.sender-data {
    width: 22%;
}

.message-data {
    width: 35%;
}

.medium-data {
    width: 14%;
    justify-content: center;
    text-align: center;
}

.tools-data {
    width: 12%;
    justify-content: center;
    text-align: center;
}

.arrow-data {
    width: 3%;
    justify-content: center;
}

.rotate-chevron {
    transform: rotate(180deg);
}

.actions-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-top: 10px;

    .row__data, .tool-icon {
        width: 22px !important;
        height: 22px !important;
        border: none !important;
    }

    .row__data {
        padding: 0 !important;
        flex: 0 0 auto !important;
    } 
}




[data-theme="dark"] {

    .message-data p {
        background-color: #46505B;
    }
}
</style>
